<template>
  <div class="home-container">
    <div class="home-content">
      <!-- 搜索 -->
      <div>
        <el-form :model="searchForm" ref="searchForm" label-width="80px">
          <el-row>
            <el-col :span="6">
              <el-form-item
                label="选择日期"
                prop="name"
                label-width="100px"
                style="width: 80%"
              >
                <el-date-picker
                  v-model="searchForm.time"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-button
                size="small"
                @click="onLoad"
                type="primary"
                icon="el-icon-search"
                style="width: 90px"
                >搜索</el-button
              >
              <el-button
                size="small"
                @click="restSearch"
                type="danger"
                style="width: 90px"
                >重置</el-button
              >
            </el-col>
          </el-row>
        </el-form>
      </div>
      <el-table :data="tableData" style="width: 100%">
        <el-table-column
          prop="address"
          label="房屋信息"
          width="200px"
          align="center"
          :fixed="tableHeader.length > 0 ? 'left' : ''"
        >
        </el-table-column>
        <div v-if="tableHeader.length > 0">
          <el-table-column
            :label="item.name"
            align="center"
            v-for="item in tableHeader"
            :key="item.id"
          >
            <el-table-column
              :prop="it.value"
              :label="it.name"
              align="center"
              v-for="(it, ind) in item.children"
              :key="ind"
            >
            </el-table-column>
          </el-table-column>
        </div>

        <el-table-column
          prop="totalAll"
          label="合计"
          width="120px"
          align="center"
          :fixed="tableHeader.length > 0 ? 'right' : ''"
        >
        </el-table-column>
      </el-table>
      <!-- 分页器 -->
      <div class="block" style="margin-top: 15px">
        <el-pagination
          align="center"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import tableList from "../../components/tableList";
export default {
  components: {
    tableList,
  },
  data() {
    return {
      searchForm: {
        time: "",
      },
      priceType: [],
      tableData: [],
      tableHeader: [],
      currentPage: 1, // 当前页码
      total: 0, // 总条数
      pageSize: 10, // 每页的数据条数
    };
  },
  mounted() {
    this.onLoad();
  },
  methods: {
    // 重置按钮
    restSearch() {
      for (let item in this.searchForm) {
        this.searchForm[item] = "";
      }
      this.onLoad();
    },
    //每页条数改变时触发 选择一页显示多少行
    handleSizeChange(val) {
      this.currentPage = 1;
      this.pageSize = val;
      this.onLoad();
    },
    //当前页改变时触发 跳转其他页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.onLoad();
    },
    onLoad() {
      let data = {
        current: this.currentPage,
        size: this.pageSize,
        time: this.searchForm.time,
      };
      this.$Apis.billDayReportForm(data).then((res) => {
        if (res.code == 200) {
          let { current, pages, list, total } = res.data;
          if (list.length > 0) {
            this.tableHeader = list[0].categoryVos;
            this.priceType = list[0].categoryVos[0].dayReportPayTypeVos;
            this.tableHeader.forEach((res, index) => {
              let arr = [];
              this.priceType.forEach((item) => {
                let priceArr = {
                  id: item.payType,
                  name: item.name,
                  value: `${res.id}-${item.payType}`,
                };
                arr.push(priceArr);
              });
              res.children = [...arr];
            });
            list.forEach((res) => {
              if (res.categoryVos && res.categoryVos.length > 0) {
                res.totalAll = 0;
                res.categoryVos.forEach((item) => {
                  item.allPrice = 0;
                  item.dayReportPayTypeVos.forEach((it) => {
                    res[`${item.id}-${it.payType}`] = it.billPrice;
                    item.allPrice += Number(it.billPrice);
                  });
                  res.totalAll += item.allPrice;
                });
              }
            });
          }

          this.tableData = list;
          this.currentPage = current;
          this.size = pages;
          this.total = total;
        }
      });
    },
  },
};
</script>

<style>
.home-container {
  padding: 10px;
  padding-top: 5px;
}
.home-content {
  padding: 10px 25px;
  border-radius: 5px;
  background: #fff;
}
</style>